import { render } from "./FDS.vue?vue&type=template&id=e3f80d24&scoped=true"
import script from "./FDS.vue?vue&type=script&lang=js"
export * from "./FDS.vue?vue&type=script&lang=js"

import "./FDS.vue?vue&type=style&index=0&id=e3f80d24&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f80d24"]])

export default __exports__